<header class="header" (scroll)="onWindowScroll($event)" [ngClass]="fixed ? 'sticky-nav' : ''">
  <div class="header-top">
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
Seller World
        </div><!-- End .header-left -->
        
        <div class="col-lg-8">
          <div class="header-left header-dropdowns">
      
            <div class="header-right">
               
                <div class="header-dropdown dropdown-expanded">
                  
                    <div class="header-menu">
                        <ul>
                          <li><a href="https://fabpik.in/" target="_blank" >fabpik.in</a></li>
                            <li><a routerLink="/faq" >Faq</a></li>
                            <!-- <li><a  >How to sell on Fabpik ?</a></li> -->
                        
                            <li><a href="https://portal.fabpik.in/seller/register" target="_blank">Register</a></li>
                            <li><a href="https://portal.fabpik.in/seller/login" target="_blank" class="login-link">LOG IN</a></li>
                        </ul>
                    </div><!-- End .header-menu -->
                </div><!-- End .header-dropown -->
            </div><!-- End .header-right -->
        </div><!-- End .container -->
        </div>
      </div>
      
</div>
</div>

<div class="header-middle">
  <div class="container">
    <div class="row">
    <div class="header-left col-lg-4 ">
     
      <a  routerLink="/" class="logo">
        <img src="assets/images/logo-1.png" alt="ogo">
      </a>
    </div>
    <div class="header-left col-lg-8 float-right">
      <div class="header-contact d-none d-lg-flex pl-1  pr-4">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-phone-call"><path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
        <h6>Call us now<a target="_blank" href="tel:{{contactDetails?.vendor_support_number}}" class="text-dark font1">{{contactDetails?.vendor_support_number}}</a></h6>
      </div>
      <div class="header-contact d-none d-lg-flex pl-1 mr-4">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-mail"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
        <h6>Mail Us<a target="_blank" href="mailto:{{contactDetails?.vendor_email}}" class="text-dark font1">{{contactDetails?.vendor_email}}</a></h6>
      </div>
   
    </div>
  
  </div>
  </div><!-- End .container -->
</div>
</header>


<router-outlet></router-outlet>
<section class="copyright">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 text-left">
<p>Fabpik © 2021.  All Rights Reserved</p>
    </div>
    
    <div class="col-lg-4 links-useful">
     <ul>
       <li><a routerLink="/faq">Faq</a></li>
       <!-- <li><a routerLink="/privacypolicy">Privacy Policy</a></li> -->
       <li><a routerLink="/termsandconditions">Terms and Conditions</a></li>
     </ul>
          </div>
  </div>
      
  </div>
</section>

